import { Bling } from "./bling";

function coopDropdown(triggers) {
  const allTriggers = triggers.length ? triggers : [triggers]
  if (!allTriggers) {
    return;
  }
  allTriggers.forEach(function (trigger) {
    const target = Bling.$(trigger.getAttribute("href"));

    trigger.addEventListener("click", function (e) {
      e.preventDefault();

      toggleDropdown(trigger, target);
    });

    target.addEventListener("click", function () {
      if (!trigger.classList.contains("coop-c-dropdown__trigger--active")) {
        return;
      }

      toggleDropdown(trigger, target);
    });
  });
}

function toggleDropdown(trigger, target) {
  trigger.classList.toggle("coop-c-dropdown__trigger--active");
  target.classList.toggle("coop-u-visuallyhidden");

  if (target.offsetHeight > 0) {
    target.setAttribute("aria-hidden", "false");
    target.setAttribute("aria-expanded", "true");
    target.setAttribute("aria-live", "polite");
  } else {
    target.setAttribute("aria-hidden", "true");
    target.removeAttribute("aria-expanded");
    target.removeAttribute("aria-live");
  }
}

export default coopDropdown;
